module.exports = __webpack_public_path__ + "img/reviews.bd2a876.svg";